<template>
  <div class="tournament-single">
    <PageHeader :cover="tournament.cover.url"></PageHeader>

    <div class="container">
      <div class="tournament-content">
        <div class="tournament-header">
          <h1>{{tournament.name}}</h1>
          <span class="time">{{tournament.starts_at}}</span>
        </div>


        <div class="tournament-headers" v-if="tournament.rounds">
          <h3 v-for="round in tournament.rounds" :key="round.round_number">
            <div v-if="round.round_number != tournament.rounds.length">Round #<span>{{round.round_number}}</span></div>
            <div v-else>Final</div>
          </h3>
        </div>

        <div class="tournament-brackets" v-if="tournament.rounds">
          <ul :class="`bracket bracket-${round.round_number}`" v-for="round in tournament.rounds" :key="round.round_number">
            <li class="team-item" v-for="match in round.matches" :key="match.id">
              <!-- <% round[1].each do |match| next if match.is_third %> -->
              <span class="match-number">#{{match.match_number}}</span>

              <div v-if="match.team_a">
                <router-link :to="{ name: 'TeamSingle', params: { id: match.team_a.to_param }}">
                  {{match.team_a.name}}
                </router-link>
              </div>
              <div v-if="!match.team_a && match.winner_from_a">Vencedor do jogo #{{match.winner_from_a.match_number}}</div>
              <time>TBA</time>

              <div v-if="match.team_b">
                <router-link :to="{ name: 'TeamSingle', params: { id: match.team_b.to_param }}">
                  {{match.team_b.name}}
                </router-link>
              </div>
              <div v-if="!match.team_b && match.winner_from_b">Vencedor do jogo #{{match.winner_from_b.match_number}}</div>
            </li>
          </ul>  
        </div>

        <div v-if="tournament.rounds.length == 0" class="no-results">
          <h4>jogos e bracket ainda não disponíveis</h4>
        </div>
        

      </div>

    </div>
  </div>
</template>

<style lang="sass" scoped>
.tournament-single
  .container
    .tournament-content
      background: #efefef
      border-left: 1px solid #fff
      border-right: 1px solid #fff
      border-bottom: 1px solid #fff
      padding: 20px

      .tournament-header
        padding: .5em 0 2em
        text-align: center
        margin: .5em 0 2em

      .content
        @media (max-width: 600px)
          img
            width: 100% !important
            height: auto !important



  .tournament-headers
    flex-grow: 1
    display: flex
    flex-direction: row
    justify-content: space-around
    border-bottom: 1px solid #ccc

    h3
      width: 34%
      text-align: center
      font-weight: 400
      border-right: 1px dashed #ccc
      margin: 0
      padding: 1rem
    
  .tournament-brackets
    display: flex
    flex-direction: row
    list-style-type: none
    background: rgba(255, 255, 255, .2)
    margin-bottom: 50px
  
  .bracket
    padding-left: 0
    display: flex
    margin: 0
    padding: 30px 0
    flex-grow: 1
    flex-direction: column
    justify-content: space-around
    list-style-type: none
    border-right: 1px dashed #ccc
    flex: 1

  .team-item
    background-color: #ccc
    padding: .5rem
    display: block
    margin: .5rem 10px
    position: relative
    vertical-align: middle
    line-height: 2
    text-align: center
    font-family: 'Rajdhani', sans-serif

    a
      color: #666
      font-weight: bold
      transition: all .2s
      &:hover
        color: #111
        // text-decoration: none

    span.match-number
      position: absolute
      top: 40px
      left: 20px
      font-weight: bold

  .team-item:after
    content: ''
    border-color: #4f7a38
    border-width: 2px
    position: absolute
    display: block
    width: 10px
    right: -11px

  .team-item:nth-of-type(odd):after
    border-right-style: solid
    border-top-style: solid
    height: 100%
    top: 50%

  .team-item:nth-of-type(even):after
    border-right-style: solid
    border-bottom-style: solid
    height: 100%
    top: -50%

  .team-item:before
    content: ''
    border-top: 2px solid #4f7a38
    position: absolute
    height: 2px
    width: 10px
    left: -10px
    top: 50%

  .bracket-2
    .team-item:nth-of-type(odd):after
      height: 200%
      top: 50%

    .team-item:nth-of-type(even):after
      height: 200%
      top: -150%
    
  .bracket-3
    .team-item:nth-of-type(odd):after
      height: 350%
      top: 50%
    
    .team-item:nth-of-type(even):after
      height: 350%
      top: -300%
    
  .bracket-4
    .team-item:nth-of-type(odd):after
      height: 700%
      top: 50%
    
    .team-item:nth-of-type(even):after
      height: 700%
      top: -650%
    
  .bracket:first-of-type
    .team-item:before
      display: none
    
  .bracket-4
    .team-item:after
      display: none
    
  .bracket:last-of-type 
    .team-item:before,
    .team-item:after
      display: none
    
  .team-item time
    display: inline-block
    background-color: #dbdbdb
    font-size: .8rem
    padding: 0 .6rem

</style>

<script>
import PageHeader from '@/components/PageHeader'
import TeamCard from '@/components/TeamCard'
export default {
  name: 'TournamentBracket',
  data () {
    return {
      tournament: { featured_image: '', title: '', id: 0, cover: {}, badge: {}, matches: [], rounds: [] },
      team_id: 0,
      teams: []
    }
  },
  metaInfo () {
    return {
      title: `${this.tournament.name}`
    }
  },
  methods: {
    initialize() {
      this.$http
        .get(`tournaments/${this.$route.params.id}.json`)
        .then(response => {
          this.tournament = response.data
        })
    }
  },
  mounted () {
    this.initialize()
  },
  watch: {
    '$route.params.id': function (id) {
      this.initialize()
    }
  },
  components: {
    PageHeader,
    TeamCard
  }
}
</script>
